import { create } from "zustand"

export const useSelectedMeshStore = create((set, get) => ({
  selectedMesh: null,
  setSelectedMesh: (mesh) => set({ selectedMesh: mesh }),
  clearSelectedMesh: () => set({ selectedMesh: null }),
}))
